export function SummaryCardSkeleton() {
    return (
        <div className="skeleton-item-container border border-grey-600 rounded-[10px] p-4 flex flex-col items-start gap-4">
            <div className="flex items-center gap-1 h-5">
                <div className="size-[14px] skeleton-item rounded"></div>
                <div className="h-[14px] w-16 skeleton-item rounded"></div>
            </div>

            <div className="h-7 w-20 skeleton-item rounded"></div>

            <div className="h-[18px] w-32 skeleton-item rounded"></div>
        </div>
    );
}
